<template>
  <div @click="onClose" id="sideBarModalComponent" class="wrapper">
    <div :class="{wrapper_body: true, open: modalData.open}">
<!--      <div class="loading_div" v-if="loading">-->
<!--        <pulse-loader :loading="loading" :color="color" class="text-center"/>-->
<!--      </div>-->
      <div class="p-2">
        <edit
          :invoiceId="modalData.invoiceId"
        />
      </div>
    </div>
  </div>
</template>

<script>

  import api from '@/api'
  import edit from "../../views/admin/invoices/edit";

  export default {
    components: {
      edit
    },
    props: ['modalData', 'onModalClose'],
    data() {
      return {
        color: '#5BBFDE',
        loading: true,
      }
    },
    mounted() {
      console.log('bar mounted');
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = "hidden";
    },
    methods: {
      async getInvoice(){
        const {data} = await api.post('/invoices/getInvoices', {

        });
      },
      onClose(e) {
        if (e.target.id === 'sideBarModalComponent') {
          const body = document.getElementsByTagName('body')[0];
          body.style.overflow = "auto";
          this.onModalClose();
        }
      }
    }
  }

</script>

<style>
  .sideBarModalComponent{

  }
</style>

<style scoped>
  .loading_div{
    position: absolute;
    top: 50%;
    left: 50%;
  }
  .wrapper_body.open{
    /*left: calc(100% - 300px);*/
    left: 25%;
    transition: all 0.3s ease 0s;
  }

  .wrapper_body {
    position: relative;
    transition: all 0.3s ease 0s;
    background-color: white;
    width: 75%;
    left: 100%;
    min-height: 100%;
    z-index: 9999;
  }

  .wrapper {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 9999;
    transition: all 0.3s ease 0s;
    background-color: rgba(0, 0, 0, 0.5);
  }
</style>
